import { useState } from 'react';
import { FaBars } from 'react-icons/fa';
import SidebarContent from './SidebarContent';

export default function Sidebar25() {
	const [isOpen, setIsOpen] = useState(false);
	const toggleSidebar = () => setIsOpen(!isOpen);

	return (
		<>
			{/* Botón hamburguesa para móviles */}
			<button
				className="btn btn-dark d-md-none position-fixed m-2"
				style={{ zIndex: 1100, width: 'auto' }}
				onClick={toggleSidebar}>
				<FaBars />
			</button>

			{/* Sidebar móvil */}
			<div
				className={`padding-for-sidebar bg-dark text-white vh-100 d-flex flex-column align-items-center
					position-fixed start-0 w-75 d-md-none sidebar-transition
					${isOpen ? 'sidebar-visible' : 'sidebar-hidden'}
				`}
				style={{ zIndex: 1000 }}>
				<SidebarContent />
			</div>

			{/* Sidebar escritorio */}
			<div className="d-none d-md-flex w-25 bg-dark text-white vh-100 flex-column align-items-center pt-4 position-relative">
				<SidebarContent />
			</div>
		</>
	);
}
